import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// CSS cascade order matters and is set by import order.
// Framework first, then our theme variables, then our own stylesheets
// (App.css and the page/component CSS pulled in by ./App).
// Bootstrap used to be imported last, which meant it overrode both
// custom.css and every stylesheet in the app.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './index.css';
import './custom.css';

import App from './App';
import { FeatureConfigProvider } from './FeatureConfigContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <FeatureConfigProvider>
        <App />
      </FeatureConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
